import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import { LastCallH5, YekanParagraph } from "../typography"
import SignUp from "../signUp"
import { FeatureCTA } from "./styled"
import { BaseContainer } from "../container/"

const LastCall = () => {
  const data = useStaticQuery(graphql`
    {
      yaml: contentYaml(header: { slug: { eq: "/index" } }) {
        content {
          lastCall {
            title
            description
          }
        }
      }
    }
  `)
  const { title, description } = data.yaml.content.lastCall

  return (
    <BaseContainer halign="center">
      <FeatureCTA>
        <LastCallH5>{title}</LastCallH5>
        <YekanParagraph>{description}</YekanParagraph>
        <SignUp hasBorder />
      </FeatureCTA>
    </BaseContainer>
  )
}

export default LastCall
